<template>
  <div class="layer-control leaflet-bottom leaflet-left" v-if="layers.length > 1 || (currentLayer && currentLayer.images.length > 1)">
    <div ref="control" class="leaflet-control-layers leaflet-control"
      @mouseover="isOpen = true"
      @mouseleave="isOpen = false"
      
      :class="{ 'leaflet-control-layers-expanded': isOpen }"
      :style="[ isOpen ? {} : { backgroundColor: color}]"
      aria-haspopup="true">
      <button @click="isOpen = true" @focus="isOpen = true" class="leaflet-control-layers-toggle" type="button" aria-label="Layers Selector"></button>
      <section class="leaflet-control-layers-list">
        <fieldset class="leaflet-control-layers-base" v-if="layers.length > 1">
          <legend><h6>{{ layersLabel }}</h6></legend>
          <label v-for="layer in layers"
                 :class="{ active: layer.id === visibleLayer }"
                 :style="[ layer.id === visibleLayer ? {border: `1px solid ${color}`} : {} ]"
                 :key="layer.id">
            <input type="radio"
                  name="layer"
                  :checked="layer.id === visibleLayer"
                  @click="$emit('select-layer', layer)"
                  class="leaflet-control-layers-selector">
            <span class="checkmark" :style="{ backgroundColor: color, borderColor: color }"></span>
            <span>{{ layer.name }}</span>
          </label>
        </fieldset>
        <fieldset class="leaflet-control-layers-base" v-if="currentLayer && currentLayer.images.length > 1">
          <legend><h6>{{ imagesLabel }}</h6></legend>
          <label v-for="image in currentLayer.images"
                 :class="{ active: image.id === visibleImage }"
                 :style="[ image.id === visibleImage ? {border: `1px solid ${color}`} : {} ]"
                 :key="image.id">
            <input type="radio"
                  name="image"
                  :checked="image.id === visibleImage"
                  @click="$emit('select-image', image)"
                  class="leaflet-control-layers-selector">
            <span class="checkmark" :style="{ backgroundColor: color, borderColor: color }"></span>
            <span>{{ image.alt_text }}</span>
          </label>
        </fieldset>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayerControl',
  props: {
    layers: {
      type: Array,
      default: () => []
    },
    visibleLayer: {
      type: Number,
      default: null
    },
    visibleImage: {
      type: Number,
      default: null
    },
    layersLabel: {
      type: String,
      default: 'Layers'
    },
    imagesLabel: {
      type: String,
      default: 'Images'
    },
    styleColors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    currentLayer () {
      return this.layers.find(x => x.id === this.visibleLayer)
    },
    color () {
      return this.styleColors[0]
    }
  }
}
</script>

<style lang="scss">
.leaflet-control-layers {
  border-radius: 50%;
  padding: 10px;
  .checkmark {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(50%, -50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #666;
    margin-left: 0;
  }
  input {
    opacity: 0;
    &:checked ~ .checkmark {
      color: #fff;
      font-family: 'ForkAwesome';
      font-weight: bold;
      &:after {
        content: "\f00c";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 8px;
      }
    }
  }
  label {
    position: relative;
    background-color: #fff;
    color: #666;
    padding: 5px 10px;
    cursor: pointer;
    &.active {
      border-radius: 2px;
    }
    span {
      margin-left: 10px;
    }

  }
  &.leaflet-control-layers-expanded {
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.8);
  }
  .leaflet-control-layers-toggle {
    background-size: 30px 30px;
    border: none;
    background-color: transparent;
  }
  .leaflet-control-layers-base {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    legend {
      display: block;
      width: 100%;
      max-width: 100%;
      padding: 0;
      margin-bottom: .5rem;
      font-size: 1.5rem;
      line-height: inherit;
      color: inherit;
      white-space: normal;
      h6 {
        margin: 0;
      }
    }
  }
}
</style>
